export function assignmentsEndIn24hours(assignment: { to: string }): boolean {
  const now = new Date();
  const oneDayLater = new Date(now.getTime() + 24 * 60 * 60 * 1000);

  const dueDate = new Date(assignment.to);

  return dueDate <= oneDayLater;
}

export function assignmentsEndIn7Days(assignment: { to: string }): boolean {
  const now = new Date();
  const sevenDaysLater = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

  const dueDate = new Date(assignment.to);

  return dueDate <= sevenDaysLater;
}
